// extracted by css-extract-rspack-plugin
export default {"content":"ti62U","icon":"GKWiU","info":"KNGWB","sub_info":"zVM1c","subInfo":"zVM1c","text":"h49ge","subtext":"_a_9K"};